<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16">
    <div class="cf-flex cf-flex--column cf-flex--gap-12">
      <h3 class="cf-title cf-title--3">
        Dine In Info:
      </h3>

      <p
        v-if="receipt.sublocationId"
        class="cf-subtitle cf-subtitle--2"
      >
        {{ userLocationType.description }}

        Number:
        <b>
          {{ receipt.sublocationId }}
        </b>
      </p>
    </div>

    <!-- Order Again Button -->
    <router-link
      v-if="isOrderAgainEnabled"
      class="cf-button cf-button--primary cf-button--md cf-button--fill"
      :to="{
        name: 'autoStartOrder',
        params: {
          merchantId: $route.params.merchantId
        },
        query: {
          lt: receipt.locationType,
          si: receipt.store.storeId,
          tb: receipt.sublocationId,
          mt: receipt.menuType,
          ft: 'dine-in'
        }
      }"
    >
      Order Again
    </router-link>

    <!-- Additional Info -->
    <template v-if="receipt.pickupInstructions">
      <cf-title-separator :omit-title="true" />

      <div class="cf-flex cf-flex--column cf-flex--gap-12">
        <h3 class="cf-title cf-title--3">
          Additional Info:
        </h3>

        <cf-formatted-content
          class="dark"
          :content="receipt.pickupInstructions"
        />
      </div>
    </template>

    <cf-title-separator :omit-title="true" />
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import currentTimestampMixin from '@/mixins/current-timestamp';

  import CfTitleSeparator from '@/view/components/shared/cf-title-separator/index.vue';

  import CfFormattedContent from '@/view/components/globals/cf-formatted-content/index.vue';


  export default {
    name: 'DineInReceiptFulfillmentDetails',

    components: {
      CfTitleSeparator,
      CfFormattedContent
    },

    mixins: [currentTimestampMixin],

    props: {
      receipt: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters('receipt', ['userLocationType']),

      isOrderAgainEnabled() {
        let shouldShow = false;

        const orderTimestampUnix = new Date(this.receipt.orderDate).getTime();

        const minutesSinceOrderWasPlaced = ((this.currentTimestampUnix - orderTimestampUnix) / 1000) / 60;

        shouldShow = minutesSinceOrderWasPlaced < 30;

        return shouldShow;
      }
    }
  };
</script>
